import { createSlice } from "@reduxjs/toolkit";
import { api } from "service/api";
import { Toast } from "service/toast";
import { AttendanceApi } from "service/apiVariables";
import { NO_DATA, addQuery } from "helpers/utis";
import { setLoader } from "./loader";
const today = new Date();

const past7Days = new Date();
past7Days.setDate(today.getDate() - 7);
export const attendanceReport = createSlice({
  name: "attendanceReport",
  initialState: {
    attendanceData: [],
    isLoading: true,
    selectedTrade: null,
    selectedProject: null,
    startDate: today.toLocaleDateString("en-CA", {
      timeZone: "Asia/Kolkata",
    }),
    endDate: past7Days.toLocaleDateString("en-CA", {
      timeZone: "Asia/Kolkata",
    }),
  },
  reducers: {
    saveAttendanceData: (state, action) => {
      state.attendanceData = action.payload;
      state.isLoading = false;
    },
    setSelectedTrade: (state, action) => {
      state.selectedTrade = action.payload;
    },
    setSelectedProject: (state, action) => {
      state.selectedProject = action.payload;
    },
    setStartDate: (state, action) => {
      state.startDate = action.payload;
    },
    setEndDate: (state, action) => {
      state.endDate = action.payload;
    },
  },
});

export const getAttendance = (query) => (dispatch) => {
  addQuery(query, AttendanceApi.getAttendanceApi);
  return new Promise((resolve, reject) => {
    api({ ...AttendanceApi.getAttendanceApi })
      .then(({ data }) => {
        dispatch(saveAttendanceData(data));
        dispatch(setLoader(false));
        resolve(data);
      })
      .catch(({ message }) => {
        dispatch(setLoader(false));
        if (message === NO_DATA) {
          dispatch(saveAttendanceData([]));
        } else {
          reject(Toast({ type: "error", message }));
        }
      });
  });
};

export const downloadAttendance = (query) => (dispatch) => {
  addQuery(query, AttendanceApi.getdownloadAttendanceApi);
  return new Promise((resolve, reject) => {
    api({ ...AttendanceApi.getdownloadAttendanceApi, method: "post" })
      .then((data) => {
        resolve(data);
      })
      .catch(({ message }) => {
        if (message === NO_DATA) {
          dispatch(saveAttendanceData([]));
        } else {
          reject(Toast({ type: "error", message }));
        }
      });
  });
};

export const getEmployeeDetail = (query) => () => {
  addQuery(query, AttendanceApi.getEmpDetailApi);
  return new Promise((resolve, reject) => {
    api({ ...AttendanceApi.getEmpDetailApi })
      .then(({ data, message }) => {
        Toast({ type: "success", message: message });
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const createAttendance = (body) => () => {
  return new Promise((resolve, reject) => {
    api({ ...AttendanceApi.createAttendanceApi, body })
      .then(({ data }) => {
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

export const generateAttendanceCron = (body) => () => {
  return new Promise((resolve, reject) => {
    api({ ...AttendanceApi.generateManualCron, body, baseURL: "cron" })
      .then((data) => {
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

export const getCronStatusReport = (body) => {
  const apiurl = AttendanceApi.getProgessStatusAPI.api(body);

  return new Promise((resolve, reject) => {
    api({ api: apiurl, baseURL: "user" })
      .then((data) => {
        console.log(data);

        resolve(data);
      })
      .catch(({ message }) => {
        Toast({ type: "error", message });
        reject(message);
      });
  });
};

// upload
export const attendanceFileUpload = (body) => () => {
  return new Promise((resolve, reject) => {
    api({ ...AttendanceApi.attendanceUploadFileApi, body })
      .then((data) => {
        Toast({ type: "success", message: data?.message });
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

export const {
  saveAttendanceData,
  setSelectedProject,
  setSelectedTrade,
  setStartDate,
  setEndDate,
} = attendanceReport.actions;

export default attendanceReport.reducer;
